<div class="pure-g m-t-8 m-b-12">
  <div class="pure-u-md-5-5">
    <mc-table [data]="equipment()?.alarms" [columns]="alarmColumns" sortdisabled fit="small"></mc-table>
  </div>
</div>
